import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Platforms.css';

const CTraders: React.FC = () => {

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
    }
  };

  return (
    <motion.div 
      className="platforms-page"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
      transition={{ staggerChildren: 0.2 }}
    >
      <div className="container">
        <motion.div className="page-title" variants={itemVariants}>
          <h1>cTrader</h1>
          <p>Institutional-grade trading platform with advanced tools</p>
        </motion.div>
        
        <motion.div className="platform-intro" variants={itemVariants}>
          <p>cTrader is an advanced trading platform designed for institutional and professional traders. It provides direct market access, sophisticated analytical tools, and a superior user experience for trading forex and CFDs.</p>

        </motion.div>
        
        <motion.div className="platform-features" variants={containerVariants}>
          <motion.div className="feature" variants={itemVariants} whileHover={{ scale: 1.03 }} transition={{ type: "spring", stiffness: 300 }}>
            <h3>Direct Market Access</h3>
            <p>Access to ECN liquidity with real-time Level II pricing and market depth</p>
          </motion.div>
          
          <motion.div className="feature" variants={itemVariants} whileHover={{ scale: 1.03 }} transition={{ type: "spring", stiffness: 300 }}>
            <h3>Advanced Charting</h3>
            <p>Over 100 technical indicators and drawing tools for comprehensive analysis</p>
          </motion.div>
          
          <motion.div className="feature" variants={itemVariants} whileHover={{ scale: 1.03 }} transition={{ type: "spring", stiffness: 300 }}>
            <h3>cBots Automated Trading</h3>
            <p>Algorithmic trading systems that can execute trades based on your strategies</p>
          </motion.div>
        </motion.div>
        
        <motion.div className="platform-actions" variants={itemVariants}>
          <h2>Get Started with cTrader</h2>
          <p>Choose the broker that best suits your trading style and requirements</p>
          <div className="btn-container">
            <Link to="/ib-partners" className="btn">View Recommended Brokers</Link>
            <Link to="/education" className="btn secondary">Learn More</Link>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default CTraders;